module.exports = __webpack_public_path__ + "static/media/pinkSmiley.5fd6061b.png";